export default __webpack_public_path__ + "static/media/chinoo.762dfcd5.png";